export default {
  w: 373,
  p: 'M37 379.81h373.333V456H37v-76.19Zm65.147-57.143h45.173l23.707-68.191h105.466l23.52 68.191h45.174L247 56h-46.667l-98.186 266.667Zm82.506-106.857 37.894-110.286h2.24L262.68 215.81h-78.027Z',
}
